import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class ServiceService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  list(query?: any) {
    return this.get('/services', query);
  }

  create(body: any) {
    return this.post('/service', body);
  }

  find(id) {
    return this.get('/service/' + id);
  }

  update(id, body) {
    return this.put('/service/' + id, body);
  }

  allService() {
    return this.get('/all-service');
  }

  _delete(id) {
    return this.post('/delete-service/', id);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Service.service.ts